exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accountInfoClass{padding-left:75px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start}.vgt-table.bordered td,.vgt-table.bordered th{border:hidden!important;background:none}.vgt-inner-wrap{-webkit-box-shadow:none!important;box-shadow:none!important}.vgt-left-align,.vgt-right-align{text-align:center}.vgt-table.bordered td,.vgt-table.bordered th{background:#fff}table.vgt-table thead th{position:sticky;top:0}*{scrollbar-width:auto;scrollbar-color:#dbd5dc #fff}::-webkit-scrollbar{width:12px}::-webkit-scrollbar-track{background:#fff}::-webkit-scrollbar-thumb{background-color:#dbd5dc;border-radius:10px;border:3px solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28247ae2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/pages/admin/investorAccount.vue
// module id = 441
// module chunks = 0